function TimeSpan() {

    function convertDaysToMilliSecs(days) {
        return days * 24 * 60 * 60 * 1000;
    }
    function convertHoursToMilliSecs(hrs) {
        return hrs * 60 * 60 * 1000;
    }
    function convertMinsToMilliSecs(mins) {
        return mins * 60 * 1000;
    }
    function convertSecsToMilliSecs(secs) {
        return secs * 1000;
    }

    function covertTimeSpanToMilliSecs(args) {
        var ISOTimeFormat, milliSecs;
        var dateObj = new Date();
        console.log(args.length)
        switch (args.length) {
            case 1:
                ISOTimeFormat = TinCan.Utils.convertMillisecondsToISO8601Duration(args[0]);
                break;
            case 2:
                milliSecs = convertDaysToMilliSecs(args[0]) + convertHoursToMilliSecs(args[1]);
                ISOTimeFormat = TinCan.Utils.convertMillisecondsToISO8601Duration(milliSecs);
                break;
            case 3:
                milliSecs = convertHoursToMilliSecs(args[0]) + convertMinsToMilliSecs(args[1]) + convertSecsToMilliSecs(args[2]);
                ISOTimeFormat = TinCan.Utils.convertMillisecondsToISO8601Duration(milliSecs);
                break;
            case 4:
                milliSecs = convertDaysToMilliSecs(args[0]) + convertHoursToMilliSecs(args[1]) + convertMinsToMilliSecs(args[2]) + convertSecsToMilliSecs(args[3]);
                ISOTimeFormat = TinCan.Utils.convertMillisecondsToISO8601Duration(milliSecs);
                break;
            case 5:
                milliSecs = convertDaysToMilliSecs(args[0]) + convertHoursToMilliSecs(args[1]) + convertMinsToMilliSecs(args[2]) + convertSecsToMilliSecs(args[3]) + args[4];
                ISOTimeFormat = TinCan.Utils.convertMillisecondsToISO8601Duration(milliSecs);
                break;
        }
        return ISOTimeFormat;


    }
    return {
        duration: function () {
            return covertTimeSpanToMilliSecs(arguments);
        }
    }

}

function ATITinCan(topicName) {
    var serviceDomain;
    var webProxyPath = "/ubt/events/";
    var contextExtUri = "http://id.tincanapi.com/extension/";
    var eventTopicSuffix = "-activity";
    var lrs, eventDetails;

    function config(env) {
        switch (env) {
            case "qa":
                serviceDomain = "https://qa-restproxy-analytics.ascendlearning.com";
                break;
            case "stage":
                serviceDomain = "https://stg-restproxy-analytics.ascendlearning.com";
                break;
            case "prod":
                serviceDomain = "https://restproxy-analytics.ascendlearning.com";
                break;
            default:
                serviceDomain = "https://qa-restproxy-analytics.ascendlearning.com";
                break;
        }
    }

    function Utility() {
        // Constructor class 
    }

    Utility.prototype.createCookie = function (name, value, secs) {
        var expires;
        if (secs) {
            var date = new Date();
            date.setTime(date.getTime() + (secs * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/;secure;";
    }

    Utility.prototype.getCookie = function (cName) {
        if (document.cookie.length > 0) {
            cStart = document.cookie.indexOf(cName + "=");
            if (cStart != -1) {
                cStart = cStart + cName.length + 1;
                cEnd = document.cookie.indexOf(";", cStart);
                if (cEnd == -1) {
                    cEnd = document.cookie.length;
                }
                return unescape(document.cookie.substring(cStart, cEnd));
            }
        }
        return "";
    }
    var utilObj = new Utility();

    function getTinCanInstance(xsrfToken) {
        if (lrs == null) {
            lrs = new TinCan.LRS({
                endpoint: serviceDomain + webProxyPath,
                auth: xsrfToken,
            });
        }
    }

    function getDefaultContextExtensions(contextExtensions) {
        var defaultContextExtensions = {};
        defaultContextExtensions = {};
        defaultContextExtensions["extensions"] = {};
        // user defined context extensions
        contextExtensions.forEach(function (value, key, map) {
            defaultContextExtensions["extensions"][contextExtUri + key] = value;
        });

        // default context extensions
        defaultContextExtensions["extensions"][contextExtUri + "tp-source-system"] = eventDetails.tpSourceSystem;
        defaultContextExtensions["extensions"][contextExtUri + "tp-user-id"] = eventDetails.userID;
        defaultContextExtensions["extensions"][contextExtUri + "session-id"] = eventDetails.sessionID;
        defaultContextExtensions["extensions"][contextExtUri + "location-type"] = eventDetails.locationType;
        defaultContextExtensions["extensions"][contextExtUri + "location"] = eventDetails.location;
        defaultContextExtensions["extensions"][contextExtUri + "application-id"] = eventDetails.applicationId + "";
        defaultContextExtensions["extensions"][contextExtUri + "statement-version"] = eventDetails.statementVersion + "";

        return defaultContextExtensions;
    }
    function getRestAPIHeaders(xsrfToken,brandName,appName,requestId) {
        return {
            "Accept": "application/vnd.kafka.v1+json, application/vnd.kafka+json, application/json",
            "Event-Name": eventDetails.eventName,
            "Authorization": xsrfToken,
            "Partition-Key-Value": eventDetails.userID,
            "Content-Type": "application/vnd.kafka.avro.v1+json",
            "Auth-Token-Type": "ClientSideSDK",
            "Brand-Name" : brandName,
            "App-Name" : appName, 
            "Request-Id" : requestId
        };
    }
         
    function saveStatement(actor, verb, activityName, sessionId, tpUserId, location, 
        locationType, contextExtensions, result,brandName,appName,requestId,saveStatementCallback) {

        eventDetails = {
            "actor": actor,
            "verb": verb,
            "activityName": activityName,
            "sessionID": sessionId,
            "userID": tpUserId,
            "location": location,
            "locationType": locationType,
            "applicationId": this.applicationId,
            "statementVersion": this.statementVersion,
            "tpSourceSystem": this.tpSourceSystem,
            "eventName": (topicName) ? topicName : ((this.tpSourceSystem == "ATI" || this.tpSourceSystem == "ATI_PLATFORM") ?
                            actor + eventTopicSuffix : this.tpSourceSystem + "-" + actor + eventTopicSuffix)
        }
        
        var statement = {
            "actor": {
                "objectType": "Agent",
                "name": actor
            },
            "verb": {
                "id": "http://adlnet.gov/expapi/verbs/" + verb
            },
            "object": {
                "objectType": "Activity",
                "id": "http://adlnet.gov/expapi/activities/" + activityName
            }
        }
        var defaultContextExtensions = getDefaultContextExtensions(contextExtensions);
        statement.context = defaultContextExtensions;
        if (result)
            statement.result = result;

        lrs.saveStatement(
            new TinCan.Statement(statement),
            {
                headers: getRestAPIHeaders(sessionId,brandName,appName,requestId),
                callback: function (err, xhr) {
                    if (err !== null) {
                        if (xhr !== null) {
                            console.log("Failed to save statement: " + xhr.responseText + " (" + xhr.status + ")");
                            if (saveStatementCallback !== null)
                                saveStatementCallback("There is a problem in saving the statement", 500);
                            return;
                        }

                        console.log("Failed to save statement: " + err);
                        if (saveStatementCallback !== null)
                            saveStatementCallback("There is a problem in saving the statement", 500);
                        return;
                    }

                    if (saveStatementCallback !== null)
                        saveStatementCallback("Statement Saved", 200);
                    console.log("Statement saved");
                }
            }
        );

    }

    function doSendTinCanEvent(actor, verb, activityName, xsrfToken, tpUserId, location,
         locationType, contextExtensions, result,brandName,appName,requestId,saveStatementCallback) {
        if(xsrfToken) {
            utilObj.__proto__.createCookie("UBT_XSRF_TOKEN", xsrfToken, 300);
            getTinCanInstance(xsrfToken);
            saveStatement.call(this, actor, verb, activityName, xsrfToken, tpUserId, location, 
                locationType, contextExtensions, result,brandName,appName,requestId, saveStatementCallback);
        } else {
            console.log("Provide a valid xsrf token!");
            if (saveStatementCallback !== null)
                saveStatementCallback("Provide a valid xsrf token!", 200);
        }
    }

    function doCreateTincanResult(success, completion, response, duration, scaled, raw, min, max, resultContextExtensions) {
        resultMap = {};
        resultMap.success = success;
        resultMap.completion = completion;
        resultMap.response = response;
        resultMap.duration = duration;
        resultMap.score = {
            "scaled": scaled,
            "raw": raw,
            "min": min,
            "max": max
        };
        resultMap.extensions = resultContextExtensions;

        return new TinCan.Result(resultMap);
    }
    return {
        tpSourceSystem: "ATI",
        applicationId: 1,
        oAuthApplicationId: 1,
        statementVersion: 1.03,
        sendTinCanEvent: function (actor, verb, activityName, xsrfToken, tpUserId, location, 
            locationType, contextExtensions, result,brandName,appName,requestId,saveStatementCallback) {
            return doSendTinCanEvent.call(this, actor, verb, activityName, xsrfToken, tpUserId, location,
                 locationType, contextExtensions, result,brandName,appName,requestId,saveStatementCallback);
       },
        createTincanResult: function (success, completion, response, duration, scaled, raw, min, max, resultContextExtensions) {
            return doCreateTincanResult(success, completion, response, duration, scaled, raw, min, max, resultContextExtensions);
        },
        environment: function (env) {
            config(env);
        },
        getCookie: function (input) {
            utilObj.__proto__.getCookie(input)
        },
        setCookie: function (name, value, secs) {
            utilObj.__proto__.createCookie(name, value, secs)
        }
    }
}